import { PageRef } from 'providers/page-ref';

// one of the three copies of this type; see components/cs-date-range-toolbar/cs-date-range-toolbar.ts
export type TimePeriod = 'week' | 'month' | 'quarter' | 'year' | 'all' | '2weeks' | '4weeks' | '8weeks' | '12weeks';

export type ChartType = 'bodyComposition' | 'nutrition';

export type ProgressPageParams = {
  timePeriod?: TimePeriod;
  chartType?: ChartType;
  startDate?: string; // ISO date
  endDate?: string; // ISO date
};

export const IProgressPage: PageRef<ProgressPageParams, void> = {
  pageName: 'ProgressPage',
} as PageRef<ProgressPageParams, void>;
